module.exports = __webpack_public_path__ + "static/media/img_cpzx@3x.7ec3eba8.png";